// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"140":"afaa07b9","213":"81b0fb88","400":"481adf3a"}[chunkId] + ".chunk.js";
};